'use strict';

export const authManagementModule = angular
  .module('app.authManagement', [])
  .config(authManagementConfig);

authManagementConfig.$inject = ['$routeProvider'];

function authManagementConfig($routeProvider) {
  $routeProvider
    .when('/set-new-password', {
      template: '<ngz-set-new-password></ngz-set-new-password>',
      pageConfig: {
        hideNavBar: true,
      },
    })
    .when('/', {
      disableCache: true,
      template: '<ngz-sign-in />',
      resolve: {
          skipIfLoggedIn: ['AuthService', function (AuthService) {
              return AuthService.skipIfLoggedIn();
          }]
      }
    })
    .when('/reset-password', {
      disableCache: true,
      template: '<ngz-forgot-password />',
      resolve: {
          skipIfLoggedIn: ['AuthService', function (AuthService) {
              return AuthService.skipIfLoggedIn();
          }]
      }
    })
    .when('/password-reset-complete', {
      disableCache: true,
      template: '<ngz-password-reset-complete />',
      pageConfig: {
        hideHeader: true,
      },
      resolve: {
          skipIfLoggedIn: ['AuthService', function (AuthService) {
              return AuthService.skipIfLoggedIn();
          }]
      }
    });
}
